import React from 'react'
import EscortRoute from '../../componentsGeneral/componentsSuperUser/studentProfile/escortRoute/EscortRoute'

const EscortRouteStudents = () => {
  return (
    <div>
        <EscortRoute/>
    </div>
  )
}

export default EscortRouteStudents